import { createContext } from "react";

const RegularClassScheduleContext = createContext();

export default RegularClassScheduleContext;
